import { SnapshotOut } from 'mobx-state-tree';
import { IQuestionModel } from '../../../state/stores/Question/QuestionModel';

/** the challenge frame drawn for a question, from its uiDesign */
const KIND_BY_DESIGN: Record<string, string> = {
  flowers: 'assessment',
  sleep_diary: 'sleepDetails',
  mood_diary: 'moodDetails',
  journaling: 'journalEntry',
};

export const frameKindOf = (question?: Pick<SnapshotOut<IQuestionModel>, 'uiDesign'> | null): string | undefined =>
  question?.uiDesign ? KIND_BY_DESIGN[question.uiDesign] : undefined;
